<template>
    <q-page class="q-pa-md">
        <carriers ref="carriers"></carriers>
    </q-page>
</template>

<script>
    export { default } from './carrierapplicationviewmodel-custom-screen.js'
</script>